export default {
  try: 'Try(NL)',
  recommendation: 'recommendation(NL)',
  noProducts: 'Geen producten',
  showInactive: 'TOON INACTIEF',
  product: 'Product',
  price: 'Prijs',
};
